export default __webpack_public_path__ + "static/media/search_institution.999839ee.svg";